import PropTypes from 'prop-types';
import React from 'react';

const RightArrowIcon = ({ className }) => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fill="currentColor"
      d="M6.542 5.816l-4.964 3.52A1 1 0 010 8.52V1.48A1 1 0 011.578.665l4.964 3.52a1 1 0 010 1.63z"
    />
  </svg>
);

RightArrowIcon.propTypes = {
  className: PropTypes.string,
};

RightArrowIcon.defaultProps = {
  className: undefined,
};

export default RightArrowIcon;
